export default __webpack_public_path__ + "static/media/baila_logo_color.c2b2846c.png";